import { render } from "./WalletTopUpReview.vue?vue&type=template&id=c72f466a&scoped=true"
import script from "./WalletTopUpReview.vue?vue&type=script&lang=ts"
export * from "./WalletTopUpReview.vue?vue&type=script&lang=ts"

import "./WalletTopUpReview.vue?vue&type=style&index=0&id=c72f466a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c72f466a"

export default script